import { useMutation } from 'react-query'

// Services
import { PostAddressVerification } from 'services/api/Address'

export default () => {
  const {
    mutate: postAddressVerification,
    data: postAddressVerificationData,
    error: postAddressVerificationError,
    isLoading: isPostAddressVerificationLoading,
    isSuccess: isPostAddressVerificationSuccess,
    isError: isPostAddressVerificationError,
  } = useMutation(PostAddressVerification)

  return {
    postAddressVerification,
    postAddressVerificationData,
    postAddressVerificationError,
    isPostAddressVerificationLoading,
    isPostAddressVerificationSuccess,
    isPostAddressVerificationError,
  }
}
